import * as React from 'react';
import {EditorEvent} from '../events';
import {editorDefaultProps, EditorProps, editorPropTypes, mapDefaultProps, MapProps, mapPropTypes} from '../props';
import {BaseMapEditor} from './BaseMapEditor';
import {useBaseProps} from '../hooks';
import {ForwardedRef, useImperativeHandle} from 'react';
import {createEditorActions, EditorActions} from '../actions';
import {createMapActions, MapActions} from '../actions/MapActions';

/**
 * Properties mapového editoru.
 */
export type MapEditorProps = MapProps<EditorEvent> & EditorProps;

/**
 * Akce mapového editoru.
 */
export type MapEditorActions = MapActions & EditorActions;

/**
 * React komponenta mapového editoru.
 *
 * - Properties: {@link MapEditorProps}.
 * - Ref: {@link MapEditorActions}.
 */
export const MapEditor = React.forwardRef(
    (props: MapEditorProps, ref: ForwardedRef<MapEditorActions>): JSX.Element => {
        const baseProps = useBaseProps();
        useImperativeHandle(ref, () => ({
            ...createMapActions(baseProps.frameDispatch),
            ...createEditorActions(baseProps.frameDispatch),
        }));
        return <BaseMapEditor {...props} {...baseProps} />;
    },
);

/**
 * Zobrazované jméno.
 */
MapEditor.displayName = 'MapEditor';

/**
 * Typy properties.
 */
MapEditor.propTypes = {
    ...mapPropTypes,
    ...editorPropTypes,
};

/**
 * Výchozí hodnoty properties.
 */
MapEditor.defaultProps = {
    ...mapDefaultProps,
    ...editorDefaultProps,
};
